import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Non-destructive buffer configuration',
  attributeName: 'nonDestructiveBuffer',
  fields: [
    {
      attributeName: 'maxSubstitutionSize',
      helpText: 'The longest amount of chunks that will be progressively replaced. Anything above this will be discarded. This makes the compute cost of doing replacements lower, improving perfomance at the cost of risking buffering. As a general rule, it is better if the max substitutions allows for a resulting buffer with total length close, or slightly above the value of bandwidthModulationSlopeEnd',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Max Substitution Size',
      placeholder: 'Input a Max Substitution Size...',
      default: 0,
    },
    {
      attributeName: 'sleepTimeNDB',
      helpText: 'How many miliseconds for "force" the Non-destructive substitution logic to sleep, in order to prevent frame drops while executing (miliseconds).',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Sleep Time NDB',
      placeholder: 'Input a Sleep Time NDB...',
      default: 0,
    },
  ],
};
